import React from 'react';
import { Play, Volume2, Maximize, MoreVertical, Phone, Headphones, Mail, Globe, MapPin, Navigation } from 'lucide-react';
import { Button } from './ui/Button';
const VIDEO_THUMB = 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1200&q=80';
function VideoPlayer() {
  return <div className="overflow-hidden rounded-xl bg-black shadow-md ring-1 ring-black/5" data-id="element-177">
      <div className="relative aspect-video w-full" data-id="element-178">
        <img src={VIDEO_THUMB} alt="Convocation ceremony crowd" className="h-full w-full object-cover" data-id="element-179" />
        <button aria-label="Play video" className="absolute inset-0 flex items-center justify-center" data-id="element-180">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/90 shadow-lg transition-transform hover:scale-105" data-id="element-181">
            <Play className="ml-1 h-7 w-7 fill-[#0f2d5c] text-[#0f2d5c]" data-id="element-182" />
          </span>
        </button>
      </div>
      {/* Fake control bar */}
      <div className="flex items-center gap-3 bg-black px-3 py-2 text-white" data-id="element-183">
        <Play className="h-4 w-4 fill-white" data-id="element-184" />
        <span className="text-xs tabular-nums" data-id="element-185">0:00 / 1:24</span>
        <div className="mx-2 h-1 flex-1 rounded-full bg-white/30" data-id="element-186">
          <div className="h-full w-1/12 rounded-full bg-white" data-id="element-187" />
        </div>
        <Volume2 className="h-4 w-4" data-id="element-188" />
        <Maximize className="h-4 w-4" data-id="element-189" />
        <MoreVertical className="h-4 w-4" data-id="element-190" />
      </div>
    </div>;
}
function ContactItem({
  icon: Icon,
  title,
  children
}: {
  icon: typeof Phone;
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-191">
      <div className="flex items-center gap-2 text-[#0f2d5c]" data-id="element-192">
        <Icon className="h-4 w-4" data-id="element-193" />
        <span className="text-sm font-semibold" data-id="element-194">{title}</span>
      </div>
      <p className="mt-1 text-sm leading-relaxed text-slate-600" data-id="element-195">{children}</p>
    </div>;
}
function VisitUs() {
  return <div className="relative rounded-xl bg-white p-6 pt-10 shadow-md ring-1 ring-black/5 lg:-ml-16" data-id="element-196">
      <div className="absolute -top-4 right-8 rounded-md bg-[#0f2d5c] px-6 py-2 text-lg font-bold text-white shadow" data-id="element-197">
        Visit Us
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-198">
        <ContactItem icon={Phone} title="Phone" data-id="element-199">
          09666775577, Ext. - 234
        </ContactItem>
        <ContactItem icon={Headphones} title="Hot line" data-id="element-200">
          +8801755587224, +8801851933094
        </ContactItem>
        <ContactItem icon={Mail} title="Email" data-id="element-201">
          admissions@ewubd.edu, info@ewubd.edu
        </ContactItem>
        <ContactItem icon={Globe} title="Web" data-id="element-202">
          https://www.ewubd.edu
        </ContactItem>
      </div>
      <div className="mt-6" data-id="element-203">
        <ContactItem icon={MapPin} title="Location" data-id="element-204">
          A/2, Jahurul Islam Avenue Jahurul Islam City, Aftabnagar Dhaka-1212,
          Bangladesh
        </ContactItem>
      </div>
      <div className="mt-6 flex justify-center" data-id="element-205">
        <Button className="gap-2 text-white" style={{
        backgroundColor: '#0f2d5c'
      }} data-id="element-206">
          <Navigation className="h-4 w-4" data-id="element-207" />
          View Our Campus Map
        </Button>
      </div>
    </div>;
}
export function VideoVisitSection() {
  return <section className="px-4 pb-20 sm:px-6" data-id="element-208">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-6 lg:grid-cols-2" data-id="element-209">
        <VideoPlayer data-id="element-210" />
        <VisitUs data-id="element-211" />
      </div>
    </section>;
}